import React from 'react'
import { Modal } from 'antd'
const HydroImportConfromModal = ({ visible, onOk }) => {
  return (
    <Modal
      title="Import Data confirmation"
      onOk={_ => onOk(true)}
      onCancel={_ => onOk(false)}
      cancelText="No"
      okText="Yes"
      width={600}
      visible={visible}
    >
      <div>Data have been imported previously. Do you want to re-import?</div>
    </Modal>
  )
}

export default HydroImportConfromModal
